const participants = [
  {
    name: 'Households',
    role: 'Energy Consumers',
    description: 'Australian homeowners looking for clearer comparisons, trusted providers and better energy outcomes through solar, batteries and smart home technology.',
    color: 'bg-primary-500',
    lightColor: 'bg-primary-50',
    textColor: 'text-primary-700',
    icon: 'ri-home-4-line',
  },
  {
    name: 'Businesses',
    role: 'Commercial Users',
    description: 'Growing Australian businesses seeking to reduce operating costs, improve energy resilience and meet sustainability targets with commercial renewable solutions.',
    color: 'bg-accent-500',
    lightColor: 'bg-accent-50',
    textColor: 'text-accent-700',
    icon: 'ri-building-4-line',
  },
  {
    name: 'Manufacturers',
    role: 'Product Suppliers',
    description: 'Renewable energy equipment manufacturers showcasing products to qualified customers and accessing a scalable digital distribution channel across Australia.',
    color: 'bg-secondary-500',
    lightColor: 'bg-secondary-50',
    textColor: 'text-secondary-700',
    icon: 'ri-cpu-line',
  },
  {
    name: 'Installers',
    role: 'Service Providers',
    description: 'Qualified solar, battery and EV charger installers receiving better-qualified enquiries and building trusted reputations through verified customer reviews.',
    color: 'bg-foreground-600',
    lightColor: 'bg-foreground-50',
    textColor: 'text-foreground-700',
    icon: 'ri-tools-line',
  },
  {
    name: 'Finance Providers',
    role: 'Funding Partners',
    description: 'Banks, green lenders and finance companies connecting with customers actively seeking renewable energy funding and green loan products.',
    color: 'bg-primary-500',
    lightColor: 'bg-primary-50',
    textColor: 'text-primary-700',
    icon: 'ri-bank-line',
  },
  {
    name: 'Energy Retailers & VPP Operators',
    role: 'Grid Partners',
    description: 'Energy retailers and virtual power plant operators preparing for the distributed energy future by connecting with battery-equipped households and businesses.',
    color: 'bg-secondary-500',
    lightColor: 'bg-secondary-50',
    textColor: 'text-secondary-700',
    icon: 'ri-flashlight-line',
  },
];

export default function SolutionSection() {
  return (
    <section id="solution" className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200/50 text-xs font-semibold tracking-wider uppercase text-primary-700 mb-5">
            The AK Energy Ecosystem
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight max-w-3xl mx-auto" style={{ color: '#111827' }}>
            One Platform For The
            <span className="relative ml-2" style={{ color: '#2FA84F' }}>
              Renewable Energy Ecosystem
            </span>
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            AK Energy simplifies renewable energy adoption by connecting every participant in the energy journey.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {participants.map((p, i) => (
            <div
              key={p.name}
              className="group bg-white rounded-2xl p-6 md:p-7 border border-background-200/70 hover:border-background-300 transition-all duration-300 hover:-translate-y-1 cursor-default"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="flex items-start gap-4 mb-4">
                <div className={`w-11 h-11 rounded-xl ${p.lightColor} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${p.icon} ${p.textColor} text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-900">{p.name}</h3>
                  <p className="text-xs text-foreground-500 font-medium mt-0.5">{p.role}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{p.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}